import React from 'react'
import { ViewQuestionnaire } from './ViewQuestionnaire'

const Questionnaires = () => {
  return (
    <>
      <ViewQuestionnaire />
    </>
  )
}

export default Questionnaires
